/**
 * DataCells - Standard row of permit/production data cells
 */

import React from "react";
import { formatGallons, formatPermit, formatAcreFeet } from "../../utils";
import { COLUMN_MODES, GALLONS_PER_ACRE_FOOT } from "../../constants";
import { StyledTableCell } from "../styled";
import { PercentBar, StatusCell } from "../atoms";

/**
 * Data cells component for production tables
 * @param {Object} props
 * @param {Object} props.totals - Totals object with all fields
 * @param {number} props.pctPermit - Percentage of permit used
 * @param {string} props.columnMode - Column display mode (full/compact)
 */
const DataCells = React.memo(({ totals, pctPermit, columnMode }) => {
  const remainingGal =
    totals.h_permit_value_gal + totals.o_permit_value_gal - totals.ytd_gal;
  const remainingAf = remainingGal / GALLONS_PER_ACRE_FOOT;
  const isNegative = remainingGal < 0;

  return (
    <>
      <StyledTableCell align="right">
        {formatPermit(totals.h_permit_af)}
      </StyledTableCell>
      <StyledTableCell align="right">
        {formatPermit(totals.o_permit_af)}
      </StyledTableCell>
      <StyledTableCell align="right">
        {formatPermit(totals.total_permit_af)}
      </StyledTableCell>
      {columnMode === COLUMN_MODES.full && (
        <>
          <StyledTableCell align="right">
            {formatGallons(totals.jan)}
          </StyledTableCell>
          <StyledTableCell align="right">
            {formatGallons(totals.feb)}
          </StyledTableCell>
          <StyledTableCell align="right">
            {formatGallons(totals.mar)}
          </StyledTableCell>
          <StyledTableCell align="right">
            {formatGallons(totals.apr)}
          </StyledTableCell>
          <StyledTableCell align="right">
            {formatGallons(totals.may)}
          </StyledTableCell>
          <StyledTableCell align="right">
            {formatGallons(totals.jun)}
          </StyledTableCell>
          <StyledTableCell align="right">
            {formatGallons(totals.jul)}
          </StyledTableCell>
          <StyledTableCell align="right">
            {formatGallons(totals.aug)}
          </StyledTableCell>
          <StyledTableCell align="right">
            {formatGallons(totals.sep)}
          </StyledTableCell>
          <StyledTableCell align="right">
            {formatGallons(totals.oct)}
          </StyledTableCell>
          <StyledTableCell align="right">
            {formatGallons(totals.nov)}
          </StyledTableCell>
          <StyledTableCell align="right">
            {formatGallons(totals.dec)}
          </StyledTableCell>
        </>
      )}
      <StyledTableCell align="right">
        {formatGallons(totals.ytd_gal)}
      </StyledTableCell>
      <StatusCell negative={isNegative}>
        {formatGallons(remainingGal)}
      </StatusCell>
      <StyledTableCell align="right">
        {formatAcreFeet(totals.ytd_af)}
      </StyledTableCell>
      <StatusCell negative={isNegative}>
        {formatAcreFeet(remainingAf)}
      </StatusCell>
      <PercentBar value={pctPermit} />
    </>
  );
});

DataCells.displayName = "DataCells";

export default DataCells;
